import { render, staticRenderFns } from "./CaseFileSectionDocuments.vue?vue&type=template&id=cdafb4a0&scoped=true&"
import script from "./CaseFileSectionDocuments.vue?vue&type=script&lang=js&"
export * from "./CaseFileSectionDocuments.vue?vue&type=script&lang=js&"
import style0 from "./CaseFileSectionDocuments.vue?vue&type=style&index=0&id=cdafb4a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdafb4a0",
  null
  
)

export default component.exports